<template>
    <div class="card mb-0 pt-2 pt-md-0">
        <div class="card-header bg-info">
            <h3 class="my-0">Nota de Crédito de Compra</h3>
        </div>
        <div class="tab-content">
            <form autocomplete="off" @submit.prevent="submit">
                <div class="form-body">
                    <div class="row">
                        <div class="col-lg-2">
                            <div class="form-group" :class="{'has-danger': errors.series}">
                                <label class="control-label">Serie <span class="text-danger">*</span></label>
                                <el-input v-model="form.series" :maxlength="4" @input="inputSeries"></el-input>

                                <small class="form-control-feedback" v-if="errors.series"
                                       v-text="errors.series[0]"></small>
                            </div>
                        </div>
                        <div class="col-lg-2">
                            <div class="form-group" :class="{'has-danger': errors.number}">
                                <label class="control-label">Número <span class="text-danger">*</span></label>
                                <el-input v-model="form.number"></el-input>

                                <small class="form-control-feedback" v-if="errors.number"
                                       v-text="errors.number[0]"></small>
                            </div>
                        </div>
                        <div class="col-lg-2">
                            <div class="form-group" :class="{'has-danger': errors.date_of_issue}">
                                <label class="control-label">Fec Emisión</label>
                                <el-date-picker v-model="form.date_of_issue"
                                                type="date" value-format="yyyy-MM-dd" :clearable="false"
                                                @change="changeDateOfIssue"></el-date-picker>
                                <small class="form-control-feedback" v-if="errors.date_of_issue"
                                       v-text="errors.date_of_issue[0]"></small>
                            </div>
                        </div>
                        <div class="col-lg-2">
                            <div class="form-group" :class="{'has-danger': errors.exchange_rate_sale}">
                                <label class="control-label">Tipo de cambio
                                    <el-tooltip class="item" effect="dark"
                                                content="Tipo de cambio del día, extraído de SUNAT" placement="top-end">
                                        <i class="fa fa-info-circle"></i>
                                    </el-tooltip>
                                </label>
                                <el-input v-model="form.exchange_rate_sale"></el-input>
                                <small class="form-control-feedback" v-if="errors.exchange_rate_sale"
                                       v-text="errors.exchange_rate_sale[0]"></small>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6">
                            <x-input v-model="form.supplier_name"
                                     label="Proveedor"
                                     :readonly="true"></x-input>
                        </div>
                        <div class="col-lg-2">
                            <x-input v-model="form.currency_type_id"
                                     label="Moneda"
                                     :readonly="true"></x-input>
                        </div>
                        <div class="col-lg-2">
                            <x-input v-model="form.affected_series"
                                     label="Serie"
                                     :readonly="true"></x-input>
                        </div>
                        <div class="col-lg-2">
                            <x-input v-model="form.affected_number"
                                     label="Número"
                                     :readonly="true"></x-input>
                        </div>
                        <div class="col-lg-2">
                            <x-input v-model="form.affected_date_of_issue"
                                     label="Fecha de emisión"
                                     :readonly="true"></x-input>
                        </div>
                    </div>
                    <!--                    <div class="row">-->
                    <!--                        <div class="col-lg-12 col-md-6 d-flex align-items-end mt-4">-->
                    <!--                            <div class="form-group">-->
                    <!--                                <button type="button" class="btn waves-effect waves-light btn-primary"-->
                    <!--                                        @click.prevent="showDialogAddItem = true">+ Agregar Producto-->
                    <!--                                </button>-->
                    <!--                            </div>-->
                    <!--                        </div>-->
                    <!--                    </div>-->
                    <div class="row" v-if="form.items.length > 0">
                        <div class="col-md-12">
                            <div class="table-responsive">
                                <table class="table">
                                    <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Nombre</th>
                                        <th class="text-center">Unidad</th>
                                        <th class="text-right">Cantidad</th>
                                        <th class="text-right">Valor Unitario</th>
                                        <th class="text-right">Precio Unitario</th>
                                        <th class="text-right">Total</th>
                                        <!--                                        <th></th>-->
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(row, index) in form.items" :key="index">
                                        <td>{{ index + 1 }}</td>
                                        <td>{{ row.name }}</td>
                                        <td class="text-center">{{ row.unit_type_id }}</td>
                                        <td class="text-right">{{ row.quantity }}</td>
                                        <td class="text-right">{{ form.currency_type_symbol }} {{ row.unit_value }}</td>
                                        <td class="text-right">{{ form.currency_type_symbol }} {{ row.unit_price }}</td>
                                        <td class="text-right">{{ form.currency_type_symbol }} {{ row.total }}</td>
                                        <!--                                        <td class="text-right">-->
                                        <!--                                            <button type="button" class="btn waves-effect waves-light btn-xs btn-danger"-->
                                        <!--                                                    @click.prevent="clickRemoveItem(index)">x-->
                                        <!--                                            </button>-->
                                        <!--                                        </td>-->
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <p class="text-right" v-if="form.total_exportation > 0">OP.EXPORTACIÓN:
                                {{ form.currency_type_symbol }} {{ form.total_exportation }}</p>
                            <p class="text-right" v-if="form.total_free > 0">OP.GRATUITAS: {{
                                    form.currency_type_symbol
                                }}
                                {{ form.total_free }}</p>
                            <p class="text-right" v-if="form.total_unaffected > 0">OP.INAFECTAS: {{
                                    form.currency_type_symbol
                                }} {{ form.total_unaffected }}</p>
                            <p class="text-right" v-if="form.total_exonerated > 0">OP.EXONERADAS:
                                {{ form.currency_type_symbol }} {{ form.total_exonerated }}</p>
                            <p class="text-right" v-if="form.total_taxed > 0">OP.GRAVADA: {{
                                    form.currency_type_symbol
                                }}
                                {{ form.total_taxed }}</p>
                            <p class="text-right" v-if="form.total_igv > 0">IGV: {{ form.currency_type_symbol }}
                                {{ form.total_igv }}</p>
                            <p v-if="form.total_isc > 0" class="text-right">ISC: {{ form.currency_type_symbol }}
                                {{ form.total_isc }}</p>
                            <h3 class="text-right" v-if="form.total > 0"><b>TOTAL: </b>{{
                                    form.currency_type_symbol
                                }} {{ form.total }}</h3>
                        </div>
                    </div>
                </div>
                <div class="form-actions text-right mt-4">
                    <el-button @click.prevent="close()">Cancelar</el-button>
                    <el-button type="primary" native-type="submit" :loading="loadingSubmit"
                               v-if="form.items.length > 0">Generar
                    </el-button>
                </div>
            </form>
        </div>

        <purchase-finish :showDialog.sync="showDialogFinish"
                         :resource="resource"
                         :record="record"
                         :show-button-new="false"></purchase-finish>
    </div>
</template>

<script>

import PurchaseFormItem from './partials/item.vue'
import PersonForm from '../persons/form.vue'
import PurchaseOptions from './partials/options.vue'
import {exchangeRate} from '../../../mixins/functions'
import XInput from "../../../components/Form/XInput";
import PurchaseFinish from "./partials/Finish";

export default {
    name: 'PurchaseNote',
    props: {
        'purchaseId': {
            required: true,
        }
    },
    components: {PurchaseFinish, XInput, PurchaseFormItem, PersonForm, PurchaseOptions},
    mixins: [exchangeRate],
    data() {
        return {
            resource: 'purchases',
            showDialogFinish: false,
            loadingSubmit: false,
            errors: {},
            form: {},
            record: {}
        }
    },
    async created() {
        await this.initForm()
        await this.changeDateOfIssue()
        await this.initRecord();
    },
    methods: {
        initForm() {
            this.errors = {}
            this.form = {
                establishment_id: null,
                document_type_id: null,
                series: null,
                number: null,
                date_of_issue: moment().format('YYYY-MM-DD'),
                time_of_issue: moment().format('HH:mm:ss'),
                supplier_id: null,
                currency_type_id: null,
                exchange_rate_sale: 0,
                total_prepayment: 0,
                total_charge: 0,
                total_discount: 0,
                total_exportation: 0,
                total_free: 0,
                total_taxed: 0,
                total_unaffected: 0,
                total_exonerated: 0,
                total_igv: 0,
                total_base_isc: 0,
                total_isc: 0,
                total_base_other_taxes: 0,
                total_other_taxes: 0,
                total_taxes: 0,
                total_value: 0,
                total: 0,
                items: [],
            }
        },
        async initRecord() {
            await this.$http.get(`/${this.resource}/note/${this.purchaseId}`)
                .then(response => {
                    this.form = Object.assign({}, this.form, response.data.form);
                })
        },
        async changeDateOfIssue() {
            this.form.date_of_due = this.form.date_of_issue
            await this.searchExchangeRateByDate(this.form.date_of_issue).then(response => {
                this.form.exchange_rate_sale = response
            })
        },
        async submit() {
            if (this.form.series === '' || _.isNull(this.form.series)) {
                this.$message.error('La serie es obligatoria')
                return false
            }
            if (this.form.number === '' || _.isNull(this.form.number)) {
                this.$message.error('La número es obligatorio')
                return false
            }

            this.loading_submit = true
            await this.$http.post(`/${this.resource}/note`, this.form)
                .then(response => {
                    if (response.data.success) {
                        this.record = response.data.data;
                        this.showDialogFinish = true
                    } else {
                        this.$message.error(response.data.message)
                    }
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        this.errors = error.response.data
                    } else {
                        this.$message.error(error.response.data.message)
                    }
                })
                .then(() => {
                    this.loading_submit = false
                })
        },
        close() {
            location.href = '/purchases'
        },
        inputSeries() {
            const pattern = new RegExp('^[A-Z0-9]+$', 'i');
            if (!pattern.test(this.form.series)) {
                this.form.series = this.form.series.substring(0, this.form.series.length - 1);
            } else {
                this.form.series = this.form.series.toUpperCase()
            }
        },
    }
}
</script>
